import {isInLabelValueArrayAsString, isValidDateTimeString} from "@utils/validators";
import {
   ACCIDENT_PARTIES_AT_FAULT_OPTIONS,
   ACCIDENT_TYPE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {objValueAsArray, objValueAsString} from "@utils/object";
import {isDateGreaterThenToday} from "@utils/date-time";

export const validateCommonPolicyHolderClaims = ({
   data,
   msgList,
}) => {
   
   if (!isInLabelValueArrayAsString(data.hasAccidentClaimsInLast5Years, YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name: 'hasAccidentClaimsInLast5Years',
         message: 'Please choose if you have accident claims in the last 5 years'
      });
      
      return;
      
   }
   
   data.hasAccidentClaimsInLast5Years = objValueAsString(data,'hasAccidentClaimsInLast5Years');
   
   if ('No' === data.hasAccidentClaimsInLast5Years) {
      return;
   }
   
   let motorAccidentsList = objValueAsArray(data, 'motorAccidentsList');
   
   if (motorAccidentsList.length === 0) {
      msgList.push({
         name: 'motorAccidentsList',
         message: 'Please add at least one accident record'
      });
      
      return;
   }
   
   motorAccidentsList.forEach((accident, accidentIndex) => {
      
      validateAccident({
         accident,
         accidentIndex,
         msgList
      })
      
   })
   
};

const validateAccident = ({accident, accidentIndex, msgList}) => {

   if(!isInLabelValueArrayAsString(accident.type,ACCIDENT_TYPE_OPTIONS)) {
      msgList.push({
         name: `motorAccidentsList.${accidentIndex}.type`,
         message: `Please specify the type of accident @ accident form ${accidentIndex + 1}`
      });
   }
   
   if(!isValidDateTimeString(accident.date)) {
      msgList.push({
         name: `motorAccidentsList.${accidentIndex}.date`,
         message: `Please specify the date of accident @ accident form ${accidentIndex + 1}`
      });
   } else if(isDateGreaterThenToday(accident.date)) {
      msgList.push({
         name: `motorAccidentsList.${accidentIndex}.date`,
         message: `The date of accident cannot be in the future @ accident form ${accidentIndex + 1}`
      });
   }
   
   if(!isInLabelValueArrayAsString(accident.partyAtFault,ACCIDENT_PARTIES_AT_FAULT_OPTIONS)) {
      msgList.push({
         name: `motorAccidentsList.${accidentIndex}.partyAtFault`,
         message: `Please specify the party at fault @ accident form ${accidentIndex + 1}`
      });
   }

};
